import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Filterkomponente für Tabellenspalten, bestehend aus einem Textfeld und einem Lösch-Icon.
 *
 * @author stoc
 */
@Component({
    selector: 'common-table-text-filter',
    templateUrl: 'table-text-filter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TableTextFilterComponent),
            multi: true
        }
    ]
})
export class TableTextFilterComponent implements ControlValueAccessor {

    value: string;

    disabled: boolean = false;

    onChange: (value: string) => void;

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange =  fn;
    }
    registerOnTouched(fn: any): void {

    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    onDelete() {
        if (this.value) {
            this.value = undefined;
            this.onChange(this.value);
        }
    }

}
